var _path, _g, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8574 56.7144C39.8574 54.5052 41.6483 52.7144 43.8574 52.7144H138.715C140.924 52.7144 142.715 54.5052 142.715 56.7144V146.571H39.8574V56.7144Z",
    fill: "url(#paint0_linear_527:46088)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_527:46088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.4287,
    y: 145.286,
    width: 115.714,
    height: 10.2857,
    rx: 5.14285,
    fill: "#0F214F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.8574,
    y: 84.8574,
    width: 42.4286,
    height: 6.42857,
    fill: "#F5FAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8574,
    y: 96.4287,
    width: 68.1429,
    height: 6.42858,
    fill: "#F5FAFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8574,
    y: 108,
    width: 68.1429,
    height: 6.42857,
    fill: "#F5FAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8574,
    y: 119.571,
    width: 20.5714,
    height: 6.42857,
    fill: "#F5FAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4088 37.0212C75.6033 47.2157 76.8744 62.9546 69.2222 74.5317L86.6691 91.9787L78.2338 100.414L60.7953 82.9764C49.2132 90.6673 33.4421 89.4078 23.2321 79.1978C11.5854 67.5511 11.5854 48.668 23.2321 37.0212C34.8789 25.3744 53.762 25.3744 65.4088 37.0212ZM31.6674 45.4566C24.6794 52.4446 24.6794 63.7745 31.6674 70.7626C38.6555 77.7506 49.9854 77.7506 56.9734 70.7626C63.9615 63.7745 63.9615 52.4446 56.9734 45.4566C49.9854 38.4685 38.6555 38.4685 31.6674 45.4566Z",
    fill: "#0F214F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6668 45.4564C24.6788 52.4444 24.6788 63.7743 31.6668 70.7623C38.6549 77.7504 49.9847 77.7504 56.9728 70.7623C63.9608 63.7743 63.9608 52.4444 56.9728 45.4564C49.9847 38.4683 38.6549 38.4683 31.6668 45.4564Z",
    fill: "url(#paint1_radial_527:46088)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.181 86.1431H167.485V91.2305H169.181V86.1431ZM161.525 89.303L160.677 90.7716L165.083 93.3153L165.93 91.8467L161.525 89.303ZM175.258 89.303L176.105 90.7717L171.7 93.3154L170.852 91.8467L175.258 89.303ZM167.602 102.642H169.297V97.5549H167.602V102.642ZM176.105 98.0137L175.257 99.4823L170.852 96.9386L171.699 95.47L176.105 98.0137ZM160.677 98.0137L161.525 99.4823L165.93 96.9386L165.082 95.47L160.677 98.0137Z",
    fill: "#77DDFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6092 117H11.9134V122.087H13.6092V117ZM5.95337 120.16L5.10547 121.629L9.5113 124.172L10.3592 122.704L5.95337 120.16ZM19.6862 120.16L20.5341 121.629L16.1283 124.172L15.2804 122.704L19.6862 120.16ZM12.0303 133.499H13.7261V128.412H12.0303V133.499ZM20.534 128.871L19.6861 130.339L15.2803 127.796L16.1282 126.327L20.534 128.871ZM5.10538 128.871L5.95329 130.339L10.3591 127.796L9.51122 126.327L5.10538 128.871Z",
    fill: "#77DDFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.323 23.1431H109.627V28.2305H111.323V23.1431ZM103.667 26.303L102.819 27.7716L107.225 30.3153L108.073 28.8467L103.667 26.303ZM117.4 26.303L118.248 27.7716L113.842 30.3154L112.994 28.8467L117.4 26.303ZM109.744 39.6423H111.44V34.5549H109.744V39.6423ZM118.248 35.0137L117.4 36.4823L112.994 33.9386L113.842 32.47L118.248 35.0137ZM102.819 35.0137L103.667 36.4823L108.073 33.9386L107.225 32.47L102.819 35.0137Z",
    fill: "#77DDFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_527:46088",
    x: 29.4287,
    y: 139.286,
    width: 123.714,
    height: 18.2856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.352941 0 0 0 0 0.756863 0 0 0 0 0.317647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_527:46088"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_527:46088",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_527:46088",
    x1: 62.9194,
    y1: 46.8997,
    x2: 116.897,
    y2: 119.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#ADF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77DDFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_527:46088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.7151 39.8573) rotate(90) scale(36 44.3968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77DDFB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.17a00ea24668660efe2fbdcc5dac7902.svg";
export { ForwardRef as ReactComponent };